import { render, staticRenderFns } from "./studyClass.vue?vue&type=template&id=23193e02&scoped=true"
import script from "./studyClass.vue?vue&type=script&lang=js"
export * from "./studyClass.vue?vue&type=script&lang=js"
import style0 from "./studyClass.vue?vue&type=style&index=0&id=23193e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23193e02",
  null
  
)

export default component.exports